module.exports = __webpack_public_path__ + "img/loginBackground.ec1c22fd.png";